import { render, staticRenderFns } from "./manifest-table.vue?vue&type=template&id=b8f35790"
import script from "./manifest-table.vue?vue&type=script&lang=js"
export * from "./manifest-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports